import { ReactElement, useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

import { useAppSelector, useModal } from 'app/hooks';
import { Tour } from 'app/types';

import MainChart from './Charts/MainChart/MainChart';
import Search from '../components/Search/Search';
import EmptyInsights from './EmptyInsights/EmptyInsights';
import SingleTourModal from './SingleTourModal/SingleTourModal';
import { getChartData } from './getChartData';
import { Spinner } from 'app/components/common';

import styles from './Insights.module.scss';

function Insights(): ReactElement {
  const [dashboardData, setDashboardData] = useState<Tour[]>([]);
  const [modalData, setModalData] = useState<Tour>(Object);
  const { isOpened, close: handleClose, open } = useModal();

  const { data: tours, loading: isToursLoading } = useAppSelector(
    (state) => state.tours,
  );

  const [lastWeekData, lastMonthData, lastYearData] =
    getChartData(dashboardData);

  useEffect(() => {
    if (tours.length > 0) {
      setDashboardData([...tours]);
    }
  }, [tours]);

  useEffect(() => {
    if (modalData?.full_id && !isOpened) {
      open();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalData]);

  const close = () => {
    handleClose();
    setModalData(Object);
  };

  return (
    <div className={styles.container}>
      <h1 className={styles.header}>
        <FormattedMessage
          id="personalInsights.header"
          defaultMessage="Analytics"
        />
      </h1>

      {isToursLoading ? (
        <Spinner size="large" style={{ margin: 'auto' }} />
      ) : tours.length ? (
        <>
          <div className={styles.heroInner}>
            <MainChart
              lastWeekData={lastWeekData}
              lastMonthData={lastMonthData}
              lastYearData={lastYearData}
            />
          </div>
          <Search initData={tours} setData={setDashboardData} />
        </>
      ) : (
        <div className={styles.inner}>
          <EmptyInsights />
        </div>
      )}

      <SingleTourModal values={{ isOpened, close }} data={modalData} />
    </div>
  );
}

export default Insights;
